var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80775 20.5C5.30258 20.5 4.875 20.325 4.525 19.975C4.175 19.625 4 19.1974 4 18.6923V5.30775C4 4.80258 4.175 4.375 4.525 4.025C4.875 3.675 5.30258 3.5 5.80775 3.5H12.1152V5H5.80775C5.73075 5 5.66025 5.03208 5.59625 5.09625C5.53208 5.16025 5.5 5.23075 5.5 5.30775V18.6923C5.5 18.7692 5.53208 18.8398 5.59625 18.9038C5.66025 18.9679 5.73075 19 5.80775 19H19.1923C19.2692 19 19.3398 18.9679 19.4038 18.9038C19.4679 18.8398 19.5 18.7692 19.5 18.6923V12.3848H21V18.6923C21 19.1974 20.825 19.625 20.475 19.975C20.125 20.325 19.6974 20.5 19.1923 20.5H5.80775ZM10.2192 15.3345L9.1655 14.2808L18.4462 5H14.5V3.5H21V10H19.5V6.05375L10.2192 15.3345Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinks);
export default __webpack_public_path__ + "static/media/open-links.37c039ccdf6dbef8153c5a750dd19e3f.svg";
export { ForwardRef as ReactComponent };